/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createTaskItemFromDiscriminatorValue, serializeDeleteTaskRequest, serializeTaskItem, serializeUpdateTaskRequest, type DeleteTaskRequest, type ErrorResponse, type InternalErrorResponse, type TaskItem, type UpdateTaskRequest } from '../../../models/index.js';
// @ts-ignore
import { StatusRequestBuilderRequestsMetadata, type StatusRequestBuilder } from './status/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/tasks/{taskItemId}
 */
export interface WithTaskItemItemRequestBuilder extends BaseRequestBuilder<WithTaskItemItemRequestBuilder> {
    /**
     * The status property
     */
    get status(): StatusRequestBuilder;
    /**
     * Removes a task from every listing and count. The removal is one-way as far as the API is concerned: a deleted task can no longer be read, edited or moved, and there is no endpoint that brings it back. Anyone who can see a task may delete it — the task's assignee, a rep who can see its customer, or an administrator — and a task outside the caller's view reads as 404. Deleting a task that is already deleted is also a 404, because a deleted task is indistinguishable from one that never existed.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: DeleteTaskRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Returns one task by its identifier. The same visibility rule as the listing applies: an administrator can read any task in the organization, while a sales rep can read only a task assigned to them or about a customer they can see. A task outside the caller's view, a deleted task and an unknown identifier all read as 404, so an identifier cannot be used to confirm that a task exists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TaskItem>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithTaskItemItemRequestBuilderGetQueryParameters> | undefined) : Promise<TaskItem | undefined>;
    /**
     * Replaces a task's title, description, due date and time, time zone, priority, assigned rep and customer with the body as sent — there is no partial update, so a field left out is cleared, and an omitted rep or customer unassigns or unlinks it. Both associations are looked up again and their names and rep numbers re-copied onto the task; a rep who is not an active member, or an unknown customer number, is a 404 and nothing changes. Status is not part of this body: complete, cancel, start or reopen a task through its status endpoint, which keeps the completion record consistent. A sales rep may edit only a task they can see, and may not move it out of their own view (403); a task they cannot see reads as 404, as do deleted tasks.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TaskItem>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateTaskRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<TaskItem | undefined>;
    /**
     * Removes a task from every listing and count. The removal is one-way as far as the API is concerned: a deleted task can no longer be read, edited or moved, and there is no endpoint that brings it back. Anyone who can see a task may delete it — the task's assignee, a rep who can see its customer, or an administrator — and a task outside the caller's view reads as 404. Deleting a task that is already deleted is also a 404, because a deleted task is indistinguishable from one that never existed.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteTaskRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Returns one task by its identifier. The same visibility rule as the listing applies: an administrator can read any task in the organization, while a sales rep can read only a task assigned to them or about a customer they can see. A task outside the caller's view, a deleted task and an unknown identifier all read as 404, so an identifier cannot be used to confirm that a task exists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithTaskItemItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Replaces a task's title, description, due date and time, time zone, priority, assigned rep and customer with the body as sent — there is no partial update, so a field left out is cleared, and an omitted rep or customer unassigns or unlinks it. Both associations are looked up again and their names and rep numbers re-copied onto the task; a rep who is not an active member, or an unknown customer number, is a 404 and nothing changes. Status is not part of this body: complete, cancel, start or reopen a task through its status endpoint, which keeps the completion record consistent. A sales rep may edit only a task they can see, and may not move it out of their own view (403); a task they cannot see reads as 404, as do deleted tasks.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateTaskRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Returns one task by its identifier. The same visibility rule as the listing applies: an administrator can read any task in the organization, while a sales rep can read only a task assigned to them or about a customer they can see. A task outside the caller's view, a deleted task and an unknown identifier all read as 404, so an identifier cannot be used to confirm that a task exists.
 */
export interface WithTaskItemItemRequestBuilderGetQueryParameters {
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithTaskItemItemRequestBuilderUriTemplate = "{+baseurl}/api/tasks/{taskItemId}{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithTaskItemItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithTaskItemItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    status: {
        requestsMetadata: StatusRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithTaskItemItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithTaskItemItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteTaskRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    get: {
        uriTemplate: WithTaskItemItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createTaskItemFromDiscriminatorValue,
    },
    put: {
        uriTemplate: WithTaskItemItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createTaskItemFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateTaskRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
